import {Navigate} from 'react-router-dom';

import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {settingsRoutes} from '@dms/routes';
import {
  AccountingActivityLog,
  AccountingCodes,
  AccountingCodesDetail,
  AccountingErrorLog,
  AccountingErrorLogDetail,
  AccountingIntegrations,
  AccountingIntegrationsAbra,
  AccountingQrCodeSettings,
  AccountingQrCodeSettingsAdd,
  AccountingQrCodeSettingsEdit,
  ComissionFee,
  CorrectiveTaxDocumentEdit,
  CorrectiveTaxDocumentNew,
  CorrectiveTaxDocuments,
  CreateOrEditInvoiceCanceling,
  CashLimits,
  CashLimitsAdd,
  CashLimitsEdit,
  CashRegisters,
  DiscountApplicationMethod,
  DocumentRoundingDefinitions,
  DocumentRoundingDefinitionsEdit,
  DocumentRoundingDefinitionsNew,
  EditCashRegister,
  ExportParametersDetail,
  MatrixManagement,
  InvoiceCanceling,
  InvoiceCostDetail,
  InvoiceCostOverview,
  InvoiceDefinition,
  InvoiceMarginOverview,
  InvoiceMarginDetail,
  NewCashRegister,
  PreAccountingProcessingDetail,
  PreAccountingProcessingNew,
  PreAccountingProcessingOverview,
  ProformaCreationDetail,
  ProformaCreationOverview,
  ProformaInvoiceGenerationDetail,
  ProformaInvoiceGenerationNew,
  ProformaInvoiceGenerationOverview,
  TaxDocumentForPaymentImportTypeDetail,
  TaxDocumentForPaymentImportTypeNew,
  TaxDocumentForPaymentIssuedTypeDetail,
  TaxDocumentForPaymentIssuedTypeNew,
  TaxDocumentImportTypeOverview,
  TaxDocumentIssuedTypeOverview,
  VatTotalAndCalculationDetail,
  VatTotalAndCalculationOverview,
} from '@dms/settings/accounting';
import {
  AdvertisingQuickPresetsCreate,
  AdvertisingQuickPresetsDetail,
  AddNewGdprConsentType,
  AdvertisingPlatformDetail,
  AdvertisingPlatforms,
  AdvertisingQuickPresets,
  AILeadEmailHistory,
  AiLeadManagement,
  BusinessCaseCentralizedPricing,
  BusinessCaseDefinition,
  BusinessCaseDueDatesDetail,
  BusinessCaseDueDatesOverview,
  BusinessCaseOfferValidityDetail,
  BusinessCaseOfferValidityOverview,
  BusinessCases,
  BussinessCaseCommissionFeeDetail,
  CarRentalSeries,
  CustomerCodeDefinition,
  CustomerCodeDefinitionDetail,
  CustomerVerification,
  CustomerVerificationDistraints,
  CustomFieldsDefinitions,
  EditGdprConsentType,
  Financing,
  GdprConsentTypes,
  Interest,
  InterestDefinition,
  InterestDefinitionDetail,
  MessageTemplateEdit,
  MessageTemplateNew,
  MessageTemplates,
  PhotosWatermarking,
  PhotosWatermarkingDetail,
  PriceGroups,
  PriceGroupsDetail,
  PriceGroupsNew,
  PromoPhotoCreate,
  PromoPhotoDetail,
  PromoPhotos,
  PurchasePrice,
  PurchasePriceRuleDetail,
  PurchasePriceRuleNew,
  Reservation,
  SalePreset,
  SalePresetDetail,
  SalesPhotosSettings,
  ServiceOrderVariants as SalesServiceOrderVariants,
  VehicleCondition,
  VehicleInspections,
  VehicleInspectionsDetail,
  VehicleInspectionsNew,
  VehicleParking,
  VehicleParkingAdd,
  VehicleParkingEdit,
  VehicleSeriesDefinition,
  VehicleEditSeriesDefinition,
  VehicleNewSeriesDefinition,
  VehicleServices,
  VehicleTopMakes,
  VehicleCustomCatalogue,
  VehicleWarehouseDetail,
  VehicleWarehouseManagement,
  Advertising,
  TitleExtensionEquipment,
  RentalCodelistDetail,
  SalesCodelistDetail,
  WorkshopCodelistDetail,
  SalesLeadsAssignmentNew,
  SalesLeadsAssignment,
  SalesLeadsAssignmentEdit,
  Campaigns,
  CampaignDetail,
  Warranty,
  WarrantyTypes,
  WarrantyTypesDetail,
} from '@dms/settings/sales';
import {
  Suppliers,
  WarehouseArticleCategory,
  WarehouseArticleCategoryDetail,
  WarehouseDetail,
  WarehouseDirectSaleVariants,
  WarehouseDirectSaleVariantsDetail,
  WarehouseMarketingCode,
  WarehouseMarketingCodeDetail,
  WarehouseSpaces,
  WarehouseSpacesDetail,
  Warehouses,
  WarehousesDispensingUnitsPresets,
  WarehousesDispensingUnitsPresetsDetail,
  WarehousesManufacturers,
  WarehousesMeasurementUnits,
  WarehousesMeasurementUnitsDetail,
  WarehousesSupplierAccounts,
  WarehousesSupplierDiscountGroups,
  WarehousesSupplierDiscountGroupsDetail,
  WarehousesSupplierOrderTypes,
  WarehousesSupplierOrderVariantsDetail,
  WarehouseSupplierOrderVariantsList,
  WarehouseTransferOrderVariants,
  WarehouseTransferOrderVariantsDetail,
} from '@dms/settings/warehouse';
import {
  CustomerContracts,
  CustomerContractsDetail,
  EmployeeCompetencesDetail,
  EmployeeCompetencesOverview,
  EmployeeCostCentersDetail,
  EmployeeCostCentersOverview,
  EmployeeProfessionsDetail,
  EmployeeProfessionsOverview,
  EmployeeWorkTeamsDetail,
  EmployeeWorkTeamsOverview,
  Inspections,
  InspectionsDetail,
  LabourCatalogues,
  LabourCataloguesDetail,
  LabourRates,
  LabourRatesDetail,
  ProductCatalog,
  ServiceCaseType,
  ServiceOrderVariants as WorkshopServiceOrderVariants,
  ServiceCaseTypeDetail,
  ServiceOrderVariantsDetail,
  TireCondition,
  TireConditionDetail,
  TireInventoryAspectRatio,
  TireInventoryAspectRatioDetail,
  TireInventoryCategory,
  TireInventoryCategoryDetail,
  TireInventoryLoadIndex,
  TireInventoryLoadIndexDetail,
  TireInventoryLocations,
  TireInventoryManufacturers,
  TireInventoryRim,
  TireInventoryRimDetail,
  TireInventorySpeedRatio,
  TireInventorySpeedRatioDetail,
  TireInventoryWidth,
  TireInventoryWidthDetail,
  TiresInventory,
  TiresInventoryDetail,
  TireTransit,
  TireTransitDetail,
  TireWarehouses,
  TireWarehousesCreate,
  TireWarehousesDetail,
  VehicleGroups,
  VehicleGroupsDetail,
  WorkshopCustomerGroupFormPage,
  WorkshopCustomerGroups,
  WorkshopInsuranceTypeDetail,
  WorkshopInsuranceTypes,
  WorkshopInterest,
  WorkshopInterestSeriesDefinition,
  WorkshopMeasurementUnitDetail,
  WorkshopMeasurementUnits,
  WorkshopSelectableMaterials,
  WorkshopSelectableMaterialsDetail,
  WorkshopServiceOrderGroupDetail,
  WorkshopServiceOrderGroups,
  WorkshopServicePackageDetail,
  WorkshopServicePackages,
  WorkshopSmallUnitMaterialDetail,
  WorkshopSmallUnitMaterials,
  WorkshopUnits,
  WorkshopUnitsDetail,
  WorkshopVehicleClassDetail,
  WorkshopVehicleClasses,
  WorkType,
  WorkTypeDetail,
  PartDepartment,
} from '@dms/settings/workshop';
import {permissions, warehousePermissions} from '@dms/shared';

import {AddTeam} from './pages/AddTeam/AddTeam';
import {AutostacjaSettings} from './pages/AutostacjaSettings/AutostacjaSettings';
import {AutostacjaSettingsSubscriptionKey} from './pages/AutostacjaSettingsSubscriptionKey/AutostacjaSettingsSubscriptionKey';
import {BackgroundRemoval} from './pages/BackgroundRemoval/BackgroundRemoval';
import {BackgroundRemovalDetail} from './pages/BackgroundRemovalDetail/BackgroundRemovalDetail';
import {BankTransferSettings} from './pages/BankTransferSettings/BankTransferSettings';
import {BillingInformationDetail} from './pages/BillingInformationDetail/BillingInformationDetail';
import {BillingInformationOverview} from './pages/BillingInformationOverview/BillingInformationOverview';
import {BranchDetail} from './pages/BranchDetail/BranchDetail';
import {BranchOverview} from './pages/BranchOverview/BranchOverview';
import {CarpassSettings} from './pages/CarpassSettings/CarpassSettings';
import {CarpassSettingsDetail} from './pages/CarpassSettingsDetail/CarpassSettingsDetail';
import {Cebia} from './pages/Cebia/Cebia';
import {CebiaRokvy} from './pages/CebiaRokvy/CebiaRokvy';
import {ChatSettings} from './pages/ChatSettings/ChatSettings';
import {Checklist} from './pages/Checklist/Checklist';
import {Create as ChecklistCreate} from './pages/Checklist/pages/Create/Create';
import {Detail as ChecklistDetail} from './pages/Checklist/pages/Detail/Detail';
import {CheckoutProfileDetail} from './pages/CheckoutProfileDetail/CheckoutProfileDetail';
import {CheckoutRuleDetail} from './pages/CheckoutRuleDetail/CheckoutRuleDetail';
import {CheckoutSettingsOverview} from './pages/CheckoutSettingsOverview/CheckoutSettingsOverview';
import {Codelists} from './pages/Codelists/Codelists';
import {DatVinDecoder} from './pages/DatVinDecoder/DatVinDecoder';
import {DigitalDeal} from './pages/DigitalDeal/DigitalDeal';
import {DocumentTemplateEditorRoute} from './pages/DocumentTemplateEditor/components/DocumentTemplateEditorRoute';
import {EmailServices} from './pages/EmailServices/EmailServices';
import {EsignoService} from './pages/EsignoService/EsignoService';
import {FacebookCredentials} from './pages/FacebookCredentials/FacebookCredentials';
import {Features} from './pages/Features/Features';
import {GeneratedDocuments} from './pages/GeneratedDocuments/GeneratedDocuments';
import {HolidayCalendar} from './pages/HolidayCalendar/HolidayCalendar';
import {InviteUserDetail} from './pages/InviteUserDetail/InviteUserDetail';
import {Jbr} from './pages/JbrSettings/components/Jbr';
import {JbrSettingsCredentials} from './pages/JbrSettingsCredentials/JbrSettingsCredentials';
import {Locale} from './pages/Locale/Locale';
import {MandatoryFields} from './pages/MandatoryFields/MandatoryFields';
import {NotificationSettingsDetail} from './pages/NotificationSettingsDetail/NotificationSettingsDetail';
import {NotificationSettingsOverview} from './pages/NotificationSettingsOverview/NotificationSettingsOverview';
import {AddOAuthClient} from './pages/OAuthClientManagement/components/AddOAuthClient';
import {OAuthClientDetail} from './pages/OAuthClientManagement/components/OAuthClientDetail';
import {OAuthClientOverview} from './pages/OAuthClientManagement/components/OAuthClientOverview';
import {OperationAuthorizationDetail} from './pages/OperationAuthorizationDetail/OperationAuthorizationDetail';
import {OperationAuthorizationsOverview} from './pages/OperationAuthorizationsOverview/OperationAuthorizationsOverview';
import {OperationDefaultsDetail} from './pages/OperationDefaultsDetail/OperationDefaultsDetail';
import {OperationDefaultsOverview} from './pages/OperationDefaultsOverview/OperationDefaultsOverview';
import {PairedDevicesOverview} from './pages/PairedDevicesOverview/PairedDevicesOverview';
import {PayPerUseMetrics} from './pages/PayPerUseMetrics/PayPerUseMetrics';
import {PhotoCheckerSettings} from './pages/PhotoCheckerSettings/PhotoCheckerSettings';
import {QrCodeDefinition} from './pages/QrCodeDefinition/QrCodeDefinition';
import {Create as RecordAuditDefinitionCreate} from './pages/RecordAuditDefinition/pages/Create/Create';
import {Detail as RecordAuditDefinitionDetail} from './pages/RecordAuditDefinition/pages/Detail/Detail';
import {RecordAuditDefinition} from './pages/RecordAuditDefinition/RecordAuditDefinition';
import {RecordAuditSeriesDefinition} from './pages/RecordAuditSeriesDefinition/RecordAuditSeriesDefinition';
import {RoleOverview} from './pages/RoleManagement/components/RoleOverview';
import {ScheduledMessagesDetail} from './pages/ScheduledMessagesDetail/ScheduledMessagesDetail';
import {ScheduledMessagesOverview} from './pages/ScheduledMessagesOverview/ScheduledMessagesOverview';
import {SeriesDefinition} from './pages/SeriesDefinition/SeriesDefinition';
import {SeriesDefinitionEdit} from './pages/SeriesDefinitionDetail/components/SeriesDefinitionEdit';
import {SeriesDefinitionNew} from './pages/SeriesDefinitionDetail/components/SeriesDefinitionNew';
import {AddServiceAccount} from './pages/ServiceAccountManagement/components/AddServiceAccount';
import {ServiceAccountDetail} from './pages/ServiceAccountManagement/components/ServiceAccountDetail';
import {ServiceAccountOverview} from './pages/ServiceAccountManagement/components/ServiceAccountOverview';
import {SmsGateways} from './pages/SmsGateways/SmsGateways';
import {SmsGatewaysKonzulta} from './pages/SmsGatewaysKonzulta/SmsGatewaysKonzulta';
import {TeamDetail} from './pages/TeamDetail/TeamDetail';
import {TeamOverview} from './pages/TeamManagement/components/TeamOverview';
import {TelephonyGroupDetail} from './pages/TelephonyGroupDetail/TelephonyGroupDetail';
import {TelephonyGroups} from './pages/TelephonyGroups/TelephonyGroups';
import {TelephonyLineDetail} from './pages/TelephonyLineDetail/TelephonyLineDetail';
import {TelephonySettings} from './pages/TelephonySettings/TelephonySettings';
import {TemplateManagement} from './pages/TemplateManagement/TemplateManagement';
import {TenantLogos} from './pages/TenantLogos/TenantLogos';
import {TenantProfile} from './pages/TenantProfile/TenantProfile';
import {TwoFactorSettings} from './pages/TwoFactorSettings/TwoFactorSettings';
import {UserDetail} from './pages/UserDetail/UserDetail';
import {UserOverviewWrapper} from './pages/UserManagement/components/UserOverviewWrapper';
import {RoleEdit} from './pages/UserManagementDetail/components/RoleEdit';
import {WhatsApp} from './pages/WhatsApp/WhatsApp';

export const SettingsModule: Module = {
  id: moduleKeys.settings,
  requiredPermission: permissions.readSettings,
  layoutProps: {
    title: 'module.settings.title',
    icon: 'action/settings',
    isLastMenuItem: true,
  },
  routerProps: {
    path: settingsRoutes.userManagement,
    element: <UserOverviewWrapper />,
  },
  content: [
    {
      id: 'checkoutProfileCreate',
      routerProps: {path: settingsRoutes.checkoutProfileCreate, element: <CheckoutProfileDetail />},
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AFTS_CHECKOUT_SETTINGS,
    },
    {
      id: 'checkoutProfileDetail',
      routerProps: {path: settingsRoutes.checkoutProfileDetail, element: <CheckoutProfileDetail />},
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AFTS_CHECKOUT_SETTINGS,
    },
    {
      id: 'checkoutProfiles',
      routerProps: {
        path: settingsRoutes.checkoutProfiles,
        element: <CheckoutSettingsOverview gridCode="checkout-profile" />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AFTS_CHECKOUT_SETTINGS,
    },
    {
      id: 'checkoutAssignmentRuleCreate',
      routerProps: {
        path: settingsRoutes.checkoutAssignmentRuleCreate,
        element: <CheckoutRuleDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AFTS_CHECKOUT_SETTINGS,
    },
    {
      id: 'checkoutAssignmentRuleDetail',
      routerProps: {
        path: settingsRoutes.checkoutAssignmentRuleDetail,
        element: <CheckoutRuleDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AFTS_CHECKOUT_SETTINGS,
    },
    {
      id: 'checkoutAssignmentRules',
      routerProps: {
        path: settingsRoutes.checkoutAssignmentRules,
        element: <CheckoutSettingsOverview gridCode="checkout-rule" />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AFTS_CHECKOUT_SETTINGS,
    },
    {
      id: 'settings-home',
      routerProps: {
        path: settingsRoutes.userManagement,
        element: <UserOverviewWrapper />,
      },
      layoutProps: {
        title: 'module.settings.title',
        icon: 'action/settings',
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising',
      routerProps: {
        path: settingsRoutes.advertising,
        element: <Advertising />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-platforms',
      routerProps: {
        path: settingsRoutes.advertisingPlatforms,
        element: <AdvertisingPlatforms />,
      },
      requiredPermission: [permissions.readSettings, permissions.toggleTenantPlatform],
    },
    {
      id: 'advertising-quickPresets',
      routerProps: {
        path: settingsRoutes.advertisingQuickPresets,
        element: <AdvertisingQuickPresets />,
      },
      requiredPermission: [permissions.readSettings, permissions.toggleTenantPlatform],
    },
    {
      id: 'advertising-quickPresets-create',
      routerProps: {
        path: settingsRoutes.advertisingQuickPresetsCreate,
        element: <AdvertisingQuickPresetsCreate />,
      },
      requiredPermission: [permissions.readSettings, permissions.toggleTenantPlatform],
    },
    {
      id: 'advertising-quickPresets-detail',
      routerProps: {
        path: settingsRoutes.advertisingQuickPresetsDetail,
        element: <AdvertisingQuickPresetsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.toggleTenantPlatform],
    },
    {
      id: 'advertising-platforms-detail',
      routerProps: {
        path: settingsRoutes.advertisingPlatformsDetail,
        element: <AdvertisingPlatformDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.toggleTenantPlatform],
    },
    {
      id: 'advertising-promoPhotos',
      routerProps: {
        path: settingsRoutes.advertisingPromoPhotos,
        element: <PromoPhotos />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-promoPhotos-create',
      routerProps: {
        path: settingsRoutes.advertisingPromoPhotosCreate,
        element: <PromoPhotoCreate />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'ai-lead-management',
      routerProps: {
        path: settingsRoutes.aiLeadManagement,
        element: <AiLeadManagement />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AI_LEAD_MANAGEMENT,
    },
    {
      id: 'ai-lead-management-history',
      routerProps: {
        path: settingsRoutes.aiLeadManagementHistory,
        element: <AILeadEmailHistory />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.AI_LEAD_MANAGEMENT,
    },
    {
      id: 'digital-deal',
      routerProps: {
        path: settingsRoutes.digitalDeal,
        element: <DigitalDeal />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.ONLINE_OFFER_SETTINGS,
    },
    {
      id: 'advertising-promoPhotos-detail',
      routerProps: {
        path: settingsRoutes.advertisingPromoPhotosDetail,
        element: <PromoPhotoDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-watermarking',
      routerProps: {
        path: settingsRoutes.advertisingWatermarking,
        element: <PhotosWatermarking />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-title-extension-equipment',
      routerProps: {
        path: settingsRoutes.advertisingTitleExtensionEquipment,
        element: <TitleExtensionEquipment />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-salesPhotos',
      routerProps: {
        path: settingsRoutes.advertisingSalesPhotos,
        element: <SalesPhotosSettings />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_PHOTO_GUIDE,
    },
    {
      id: 'esignoService',
      routerProps: {
        path: settingsRoutes.esignoDetail,
        element: <EsignoService />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'photoCheckerSettings',
      routerProps: {
        path: settingsRoutes.photoChecker,
        element: <PhotoCheckerSettings />,
      },
      requiredPermission: [permissions.readSettings, permissions.updatePhotoCheckerConfig],
    },
    {
      // Kept for bookmarks and links from before PhotoChecker settings moved under Advertising.
      id: 'photoCheckerSettings-legacy-redirect',
      routerProps: {
        path: `${settingsRoutes.vehicleServices}/photo-checker`,
        element: <Navigate to={settingsRoutes.photoChecker} replace />,
      },
      requiredPermission: [permissions.readSettings, permissions.updatePhotoCheckerConfig],
    },
    {
      id: 'advertising-watermarking-detail',
      routerProps: {
        path: settingsRoutes.advertisingWatermarkingDetail,
        element: <PhotosWatermarkingDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'PairedDevicesOverview',
      routerProps: {
        path: settingsRoutes.signatures,
        element: <PairedDevicesOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-watermarking-create',
      routerProps: {
        path: settingsRoutes.advertisingWatermarkingCreate,
        element: <PhotosWatermarkingDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'advertising-qrCodeDefinition',
      routerProps: {
        path: settingsRoutes.advertisingQrCodeDefinition,
        element: <QrCodeDefinition />,
      },
      requiredPermission: [permissions.readSettings],
    },
    {
      id: 'advertising-backgroundRemoval',
      routerProps: {
        path: settingsRoutes.backgroundRemoval,
        element: <BackgroundRemoval />,
      },
      requiredPermission: permissions.configureBackgroundRemoval,
    },
    {
      id: 'advertising-backgroundRemovalDetail',
      routerProps: {
        path: settingsRoutes.backgroundRemovalDetail,
        element: <BackgroundRemovalDetail />,
      },
      requiredPermission: permissions.configureBackgroundRemoval,
    },
    {
      id: 'advertising-backgroundRemovalCreate',
      routerProps: {
        path: settingsRoutes.backgroundRemovalCreate,
        element: <BackgroundRemovalDetail />,
      },
      requiredPermission: permissions.configureBackgroundRemoval,
    },
    {
      id: 'advertising-salePreset',
      routerProps: {
        path: settingsRoutes.salePreset,
        element: <SalePreset />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_SALE_PROGRAMS,
    },
    {
      id: 'advertising-salePresetDetail',
      routerProps: {
        path: settingsRoutes.salePresetDetail,
        element: <SalePresetDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_SALE_PROGRAMS,
    },
    {
      id: 'rental-vehicle-priceGroupList',
      routerProps: {
        path: settingsRoutes.priceGroupList,
        element: <PriceGroups />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'rental-vehicle-priceGroupNew',
      routerProps: {
        path: settingsRoutes.priceGroupNew,
        element: <PriceGroupsNew />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'rental-vehicle-priceGroupDetail',
      routerProps: {
        path: settingsRoutes.priceGroupDetail,
        element: <PriceGroupsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'rental-vehicle-carRentalSeries',
      routerProps: {
        path: settingsRoutes.carRentalSeries,
        element: <CarRentalSeries />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRentalVehicle],
    },
    {
      id: 'advertising-salePresetCreate',
      routerProps: {
        path: settingsRoutes.salePresetCreate,
        element: <SalePresetDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_SALE_PROGRAMS,
    },
    {
      id: 'businessCases',
      routerProps: {
        path: settingsRoutes.businessCase,
        element: <BusinessCases />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-dueDates',
      routerProps: {
        path: settingsRoutes.businessCaseDueDates,
        element: <BusinessCaseDueDatesOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-dueDatesDetail',
      routerProps: {
        path: settingsRoutes.businessCaseDueDatesDetail,
        element: <BusinessCaseDueDatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-dueDatesNew',
      routerProps: {
        path: settingsRoutes.businessCaseDueDatesNew,
        element: <BusinessCaseDueDatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCase-offerValidity',
      routerProps: {
        path: settingsRoutes.businessCaseOfferValidity,
        element: <BusinessCaseOfferValidityOverview />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.OFFER_VALIDITY,
    },
    {
      id: 'businessCase-offerValidityDetail',
      routerProps: {
        path: settingsRoutes.businessCaseOfferValidityDetail,
        element: <BusinessCaseOfferValidityDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.OFFER_VALIDITY,
    },
    {
      id: 'businessCase-offerValidityNew',
      routerProps: {
        path: settingsRoutes.businessCaseOfferValidityNew,
        element: <BusinessCaseOfferValidityDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.OFFER_VALIDITY,
    },
    {
      id: 'businessCases-definition',
      routerProps: {
        path: settingsRoutes.businessCaseDefinition,
        element: <BusinessCaseDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-commissionFee',
      routerProps: {
        path: settingsRoutes.businessCaseCommissionFee,
        element: <ComissionFee />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-editCommissionFee',
      routerProps: {
        path: settingsRoutes.businessCaseEditCommissionFee,
        element: <BussinessCaseCommissionFeeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-createCommissionFee',
      routerProps: {
        path: settingsRoutes.businessCaseCreateCommissionFee,
        element: <BussinessCaseCommissionFeeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'businessCases-centralizedPricing',
      routerProps: {
        path: settingsRoutes.businessCaseCentralizedPricing,
        element: <BusinessCaseCentralizedPricing />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleWarehouseManagement',
      routerProps: {
        path: settingsRoutes.vehicleWarehouseManagement,
        element: <VehicleWarehouseManagement />,
      },
      requiredPermission: [permissions.readSettings, permissions.vehicleWarehouseRead],
      requiredFeatureFlag: featureFlags.VEHICLE_WAREHOUSE,
    },
    {
      id: 'vehicleWarehouseCreate',
      routerProps: {
        path: settingsRoutes.vehicleWarehouseCreate,
        element: <VehicleWarehouseDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.vehicleWarehouseRead],
      requiredFeatureFlag: featureFlags.VEHICLE_WAREHOUSE,
    },
    {
      id: 'vehicleWarehouseEdit',
      routerProps: {
        path: settingsRoutes.vehicleWarehouseEdit,
        element: <VehicleWarehouseDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.vehicleWarehouseRead],
      requiredFeatureFlag: featureFlags.VEHICLE_WAREHOUSE,
    },
    {
      id: 'interest',
      routerProps: {
        path: settingsRoutes.interest,
        element: <Interest />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'interestDefinition',
      routerProps: {
        path: settingsRoutes.interestDefinition,
        element: <InterestDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'interestDefinitionDetail',
      routerProps: {
        path: settingsRoutes.interestDefinitionDetail,
        element: <InterestDefinitionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesLeadsAssignment',
      routerProps: {
        path: settingsRoutes.salesLeadsAssignment,
        element: <SalesLeadsAssignment />,
      },
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesLeadsAssignmentNew',
      routerProps: {
        path: settingsRoutes.salesLeadsAssignmentNew,
        element: <SalesLeadsAssignmentNew />,
      },
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesLeadsAssignmentEdit',
      routerProps: {
        path: settingsRoutes.salesLeadsAssignmentEdit,
        element: <SalesLeadsAssignmentEdit />,
      },
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'campaigns',
      routerProps: {
        path: settingsRoutes.campaigns,
        element: <Campaigns />,
      },
      requiredFeatureFlag: featureFlags.CAMPAIGNS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'campaignsNew',
      routerProps: {
        path: settingsRoutes.campaignsNew,
        element: <CampaignDetail />,
      },
      requiredFeatureFlag: featureFlags.CAMPAIGNS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'campaignEdit',
      routerProps: {
        path: settingsRoutes.campaignEdit,
        element: <CampaignDetail />,
      },
      requiredFeatureFlag: featureFlags.CAMPAIGNS,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'productCatalog',
      routerProps: {
        path: settingsRoutes.productCatalog,
        element: <ProductCatalog />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'codelists',
      routerProps: {
        path: settingsRoutes.codelists,
        element: <Codelists />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'sales-codelistDetail',
      routerProps: {
        path: settingsRoutes.codelistDetail,
        element: <SalesCodelistDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'rental-codelistDetail',
      routerProps: {
        path: settingsRoutes.editRentalCodeList,
        element: <RentalCodelistDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'notificationsOverview',
      routerProps: {
        path: settingsRoutes.notificationsOverview,
        element: <NotificationSettingsOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'notificationsDetail',
      routerProps: {
        path: settingsRoutes.notificationsDetail,
        element: <NotificationSettingsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleTopMakes',
      routerProps: {
        path: settingsRoutes.vehicleTopMakes,
        element: <VehicleTopMakes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleCustomCatalogue',
      routerProps: {
        path: settingsRoutes.vehicleCustomCatalogue,
        element: <VehicleCustomCatalogue />,
      },
      // vehicleRead as well, so route access matches the navigation entry, which sits in the
      // Vehicle section behind that same permission. Without it the page would be reachable by
      // direct URL for users who cannot see the link.
      requiredPermission: [permissions.readSettings, permissions.vehicleRead],
    },
    {
      id: 'vehicleSeriesDefinition',
      routerProps: {
        path: settingsRoutes.vehicleSeriesDefinition,
        element: <VehicleSeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleNewSeriesDefinition',
      routerProps: {
        path: settingsRoutes.vehicleNewSeriesDefinition,
        element: <VehicleNewSeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleEditSeriesDefinition',
      routerProps: {
        path: settingsRoutes.vehicleEditSeriesDefinition,
        element: <VehicleEditSeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleInspections',
      routerProps: {
        path: settingsRoutes.vehicleInspections,
        element: <VehicleInspections />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleInspectionsNew',
      routerProps: {
        path: settingsRoutes.vehicleInspectionsNew,
        element: <VehicleInspectionsNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleInspectionsEdit',
      routerProps: {
        path: settingsRoutes.vehicleInspectionDetail,
        element: <VehicleInspectionsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleCondition',
      routerProps: {
        path: settingsRoutes.vehicleCondition,
        element: <VehicleCondition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleParking',
      routerProps: {
        path: settingsRoutes.vehicleParking,
        element: <VehicleParking />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleParkingAdd',
      routerProps: {
        path: settingsRoutes.vehicleParkingAdd,
        element: <VehicleParkingAdd />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleParkingEdit',
      routerProps: {
        path: settingsRoutes.vehicleParkingEdit,
        element: <VehicleParkingEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerDefinition',
      routerProps: {
        path: settingsRoutes.customerCodeDefinition,
        element: <CustomerCodeDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerCodeDetail',
      routerProps: {
        path: settingsRoutes.customerCodeDefinitionDetail,
        element: <CustomerCodeDefinitionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'bankTransferSettings',
      routerProps: {
        path: settingsRoutes.bankTransferSettings,
        element: <BankTransferSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagement',
      routerProps: {
        path: settingsRoutes.userManagement,
        element: <UserOverviewWrapper />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'roleManagement',
      routerProps: {
        path: settingsRoutes.roleManagement,
        element: <RoleOverview />,
      },
      requiredPermission: permissions.updateRole,
    },
    {
      id: 'teamManagement',
      routerProps: {
        path: settingsRoutes.teamManagement,
        element: <TeamOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.teamRead],
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
    },
    {
      id: 'teamManagementAddTeam',
      routerProps: {
        path: settingsRoutes.teamManagementAddTeam,
        element: <AddTeam />,
      },
      requiredPermission: [permissions.readSettings, permissions.teamCreate],
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
    },
    {
      id: 'teamManagementDetail',
      routerProps: {
        path: settingsRoutes.teamManagementDetail,
        element: <TeamDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.teamRead],
      requiredFeatureFlag: featureFlags.CORE_TEAMS,
    },
    {
      id: 'userManagementDetailV2',
      routerProps: {
        path: settingsRoutes.userManagementDetailV2,
        element: <UserDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagementAddUserV2',
      routerProps: {
        path: settingsRoutes.userManagementAddUserV2,
        element: <UserDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'userManagementInviteUser',
      routerProps: {
        path: settingsRoutes.userManagementInviteUser,
        element: <InviteUserDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'roleManagementDetail',
      routerProps: {
        path: settingsRoutes.roleManagementDetail,
        element: <RoleEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceAccountManagement',
      routerProps: {
        path: settingsRoutes.serviceAccountManagement,
        element: <ServiceAccountOverview />,
      },
      requiredPermission: permissions.readServiceAccount,
    },
    {
      id: 'serviceAccountManagementCreate',
      routerProps: {
        path: settingsRoutes.serviceAccountManagementCreate,
        element: <AddServiceAccount />,
      },
      requiredPermission: permissions.createServiceAccount,
    },
    {
      id: 'serviceAccountManagementDetail',
      routerProps: {
        path: settingsRoutes.serviceAccountManagementDetail,
        element: <ServiceAccountDetail />,
      },
      requiredPermission: permissions.readServiceAccount,
    },
    {
      id: 'oauthClientManagement',
      routerProps: {
        path: settingsRoutes.oauthClientManagement,
        element: <OAuthClientOverview />,
      },
      requiredPermission: permissions.readOAuthClient,
      requiredFeatureFlag: featureFlags.OAUTH_CLIENTS_MANAGEMENT,
    },
    {
      id: 'oauthClientManagementCreate',
      routerProps: {
        path: settingsRoutes.oauthClientManagementCreate,
        element: <AddOAuthClient />,
      },
      requiredPermission: permissions.createOAuthClient,
      requiredFeatureFlag: featureFlags.OAUTH_CLIENTS_MANAGEMENT,
    },
    {
      id: 'oauthClientManagementDetail',
      routerProps: {
        path: settingsRoutes.oauthClientManagementDetail,
        element: <OAuthClientDetail />,
      },
      requiredPermission: permissions.readOAuthClient,
      requiredFeatureFlag: featureFlags.OAUTH_CLIENTS_MANAGEMENT,
    },
    {
      id: 'documentTemplateEditor',
      routerProps: {
        path: settingsRoutes.documentTemplateEditor,
        element: <DocumentTemplateEditorRoute />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.DOCUMENT_TEMPLATE_EDITOR,
    },
    {
      id: 'templateManagement',
      routerProps: {
        path: settingsRoutes.templateManagement,
        element: <TemplateManagement />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouses',
      routerProps: {
        path: settingsRoutes.warehousesList,
        element: <Warehouses />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDetail',
      routerProps: {
        paths: [settingsRoutes.warehousesDetail, settingsRoutes.warehousesCreate],
        element: <WarehouseDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMarketingCode',
      routerProps: {
        path: settingsRoutes.warehousesMarketingCode,
        element: <WarehouseMarketingCode />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMarketingCodeAdd',
      routerProps: {
        path: settingsRoutes.warehousesMarketingCodeCreate,
        element: <WarehouseMarketingCodeDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMarketingCodeDetail',
      routerProps: {
        path: settingsRoutes.warehousesMarketingCodeDetail,
        element: <WarehouseMarketingCodeDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDirectSaleVariants',
      routerProps: {
        path: settingsRoutes.warehousesDirectSaleVariants,
        element: <WarehouseDirectSaleVariants />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDirectSaleVariantsAdd',
      routerProps: {
        path: settingsRoutes.warehousesDirectSaleVariantsCreate,
        element: <WarehouseDirectSaleVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseDirectSaleVariantsDetail',
      routerProps: {
        path: settingsRoutes.warehousesDirectSaleVariantsDetail,
        element: <WarehouseDirectSaleVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderVariantsList',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderVariants,
        element: <WarehouseSupplierOrderVariantsList />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderVariantsAdd',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderVariantsCreate,
        element: <WarehousesSupplierOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderVariantsDetail,
        element: <WarehousesSupplierOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseTransferOrderVariants',
      routerProps: {
        path: settingsRoutes.warehousesTransferOrderVariants,
        element: <WarehouseTransferOrderVariants />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseTransferOrderVariantsAdd',
      routerProps: {
        path: settingsRoutes.warehousesTransferOrderVariantsCreate,
        element: <WarehouseTransferOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseTransferOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.warehousesTransferOrderVariantsDetail,
        element: <WarehouseTransferOrderVariantsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseArticleCategory',
      routerProps: {
        path: settingsRoutes.warehousesArticleCategory,
        element: <WarehouseArticleCategory />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseArticleCategoryAdd',
      routerProps: {
        path: settingsRoutes.warehousesArticleCategoryCreate,
        element: <WarehouseArticleCategoryDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseArticleCategoryDetail',
      routerProps: {
        path: settingsRoutes.warehousesArticleCategoryDetail,
        element: <WarehouseArticleCategoryDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseManufacturers',
      routerProps: {
        path: settingsRoutes.warehousesManufacturers,
        element: <WarehousesManufacturers />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMeasurementUnits',
      routerProps: {
        path: settingsRoutes.warehousesMeasurementUnits,
        element: <WarehousesMeasurementUnits />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseMeasurementUnitsAdd',
      routerProps: {
        path: settingsRoutes.warehousesMeasurementUnitsCreate,
        element: <WarehousesMeasurementUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseMeasurementUnitsDetail',
      routerProps: {
        path: settingsRoutes.warehousesMeasurementUnitsDetail,
        element: <WarehousesMeasurementUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseDispensingUnitsPresets',
      routerProps: {
        path: settingsRoutes.warehousesDispensingUnitsPresets,
        element: <WarehousesDispensingUnitsPresets />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseDispensingUnitsPresetsAdd',
      routerProps: {
        path: settingsRoutes.warehousesDispensingUnitsPresetsCreate,
        element: <WarehousesDispensingUnitsPresetsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseDispensingUnitsPresetsDetail',
      routerProps: {
        path: settingsRoutes.warehousesDispensingUnitsPresetsDetail,
        element: <WarehousesDispensingUnitsPresetsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warehouseSupplierAccounts',
      routerProps: {
        path: settingsRoutes.warehousesSupplierAccounts,
        element: <WarehousesSupplierAccounts />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierOrderTypes',
      routerProps: {
        path: settingsRoutes.warehousesSupplierOrderTypes,
        element: <WarehousesSupplierOrderTypes />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierDiscountGroups',
      routerProps: {
        path: settingsRoutes.warehousesSupplierDiscountGroups,
        element: <WarehousesSupplierDiscountGroups />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSupplierDiscountGroupsDetail',
      routerProps: {
        path: settingsRoutes.warehousesSupplierDiscountGroupsDetail,
        element: <WarehousesSupplierDiscountGroupsDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSpaces',
      routerProps: {
        path: settingsRoutes.warehousesSpaces,
        element: <WarehouseSpaces />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSpacesCreate',
      routerProps: {
        path: settingsRoutes.warehousesSpacesCreate,
        element: <WarehouseSpacesDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'warehouseSpacesDetail',
      routerProps: {
        path: settingsRoutes.warehousesSpacesDetail,
        element: <WarehouseSpacesDetail />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'suppliers',
      routerProps: {
        path: settingsRoutes.suppliers,
        element: <Suppliers />,
      },
      requiredPermission: warehousePermissions.warehouseDictionaryRead,
    },
    {
      id: 'gdprConsent',
      routerProps: {
        path: settingsRoutes.gdprConsentTypes,
        element: <GdprConsentTypes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'gdprConsentEdit',
      routerProps: {
        path: settingsRoutes.gdprConsentTypesEdit,
        element: <EditGdprConsentType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'gdprConsentAdd',
      routerProps: {
        path: settingsRoutes.gdprConsentTypesNew,
        element: <AddNewGdprConsentType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tenant',
      routerProps: {
        path: settingsRoutes.tenant,
        element: <TenantProfile />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'payPerUseMetrics',
      routerProps: {
        path: settingsRoutes.payPerUseMetrics,
        element: <PayPerUseMetrics />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tenantLogos',
      routerProps: {
        path: settingsRoutes.tenantLogos,
        element: <TenantLogos />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'holidayCalendar',
      routerProps: {
        path: settingsRoutes.holidayCalendar,
        element: <HolidayCalendar />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'telephony',
      routerProps: {
        path: settingsRoutes.telephony,
        element: <TelephonySettings />,
      },
      requiredPermission: [permissions.readSettings, permissions.telephonySettingsRead],
      requiredFeatureFlag: featureFlags.CORE_TELEPHONY,
    },
    {
      id: 'telephonyLineDetail',
      routerProps: {
        path: settingsRoutes.telephonyLineDetail,
        element: <TelephonyLineDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.telephonySettingsRead],
      requiredFeatureFlag: featureFlags.CORE_TELEPHONY,
    },
    {
      id: 'telephonyGroups',
      routerProps: {
        path: settingsRoutes.telephonyGroups,
        element: <TelephonyGroups />,
      },
      requiredPermission: [permissions.readSettings, permissions.telephonySettingsRead],
      requiredFeatureFlag: featureFlags.CORE_TELEPHONY,
    },
    {
      id: 'telephonyGroupCreate',
      routerProps: {
        path: settingsRoutes.telephonyGroupCreate,
        element: <TelephonyGroupDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.telephonySettingsWrite],
      requiredFeatureFlag: featureFlags.CORE_TELEPHONY,
    },
    {
      id: 'telephonyGroupDetail',
      routerProps: {
        path: settingsRoutes.telephonyGroupDetail,
        element: <TelephonyGroupDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.telephonySettingsRead],
      requiredFeatureFlag: featureFlags.CORE_TELEPHONY,
    },
    {
      id: 'billingInfo',
      routerProps: {
        path: settingsRoutes.billingInformation,
        element: <BillingInformationOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'billingInfoEdit',
      routerProps: {
        path: settingsRoutes.billingInformationEdit,
        element: <BillingInformationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'billingInfoNew',
      routerProps: {
        path: settingsRoutes.billingInformationNew,
        element: <BillingInformationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customFields',
      routerProps: {
        path: settingsRoutes.customFields,
        element: <CustomFieldsDefinitions />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warranty',
      routerProps: {
        path: settingsRoutes.warranty,
        element: <Warranty />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_WARRANTY,
    },
    {
      id: 'seriesDefinition',
      routerProps: {
        path: settingsRoutes.seriesDefinition,
        element: <SeriesDefinition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'seriesDefinitionEdit',
      routerProps: {
        path: settingsRoutes.seriesDefinitionEdit,
        element: <SeriesDefinitionEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'seriesDefinitionNew',
      routerProps: {
        path: settingsRoutes.seriesDefinitionNew,
        element: <SeriesDefinitionNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'correctiveTaxDocuments',
      routerProps: {
        path: settingsRoutes.correctiveTaxDocuments,
        element: <CorrectiveTaxDocuments />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'correctiveTaxDocumentsNew',
      routerProps: {
        path: settingsRoutes.correctiveTaxDocumentsNew,
        element: <CorrectiveTaxDocumentNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'correctiveTaxDocumentsEdit',
      routerProps: {
        path: settingsRoutes.correctiveTaxDocumentsEdit,
        element: <CorrectiveTaxDocumentEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'messageTemplates',
      routerProps: {
        path: settingsRoutes.messageTemplates,
        element: <MessageTemplates />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'messageTemplatesNew',
      routerProps: {
        path: settingsRoutes.messageTemplatesNew,
        element: <MessageTemplateNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'messageTemplatesEdit',
      routerProps: {
        path: settingsRoutes.messageTemplatesEdit,
        element: <MessageTemplateEdit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'branches',
      routerProps: {
        path: settingsRoutes.branches,
        element: <BranchOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'branchEdit',
      routerProps: {
        path: settingsRoutes.branchesEdit,
        element: <BranchDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'branchNew',
      routerProps: {
        path: settingsRoutes.branchesNew,
        element: <BranchDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'cashRegisters',
      routerProps: {
        path: settingsRoutes.cashRegisters,
        element: <CashRegisters />,
      },
      requiredPermission: [permissions.readSettings, permissions.readCashRegisterDocument],
    },
    {
      id: 'cashRegisterEdit',
      routerProps: {
        path: settingsRoutes.cashRegistersDetail,
        element: <EditCashRegister />,
      },
      requiredPermission: [permissions.readSettings, permissions.readCashRegisterDocument],
    },
    {
      id: 'newCashRegister',
      routerProps: {
        path: settingsRoutes.newCashRegister,
        element: <NewCashRegister />,
      },
      requiredPermission: [permissions.readSettings, permissions.readCashRegisterDocument],
    },
    {
      id: 'cashLimits',
      routerProps: {
        path: settingsRoutes.cashLimits,
        element: <CashLimits />,
      },
      requiredPermission: [permissions.readSettings, permissions.createCashRegisterDocument],
    },
    {
      id: 'cashLimitEdit',
      routerProps: {
        path: settingsRoutes.cashLimitsEdit,
        element: <CashLimitsEdit />,
      },
      requiredPermission: [permissions.readSettings, permissions.createCashRegisterDocument],
    },
    {
      id: 'cashLimitAdd',
      routerProps: {
        path: settingsRoutes.cashLimitsAdd,
        element: <CashLimitsAdd />,
      },
      requiredPermission: [permissions.readSettings, permissions.createCashRegisterDocument],
    },
    {
      id: 'qrCodeSettings',
      routerProps: {
        path: settingsRoutes.qrCodeSettings,
        element: <AccountingQrCodeSettings />,
      },
      requiredPermission: [permissions.readSettings, permissions.readQrCode],
    },
    {
      id: 'qrCodeSettingsEdit',
      routerProps: {
        path: settingsRoutes.qrCodeSettingsEdit,
        element: <AccountingQrCodeSettingsEdit />,
      },
      requiredPermission: [permissions.readSettings, permissions.updateQrCode],
    },
    {
      id: 'qrCodeSettingsAdd',
      routerProps: {
        path: settingsRoutes.qrCodeSettingsAdd,
        element: <AccountingQrCodeSettingsAdd />,
      },
      requiredPermission: [permissions.readSettings, permissions.createQrCode],
    },
    {
      id: 'invoiceDefinition',
      routerProps: {
        path: settingsRoutes.invoiceDefinition,
        element: <InvoiceDefinition />,
      },
      requiredPermission: [permissions.readSettings, permissions.createInvoice],
    },
    {
      id: 'documentRoundingDefinitions',
      routerProps: {
        path: settingsRoutes.documentRoundingDefinitions,
        element: <DocumentRoundingDefinitions />,
      },
      requiredPermission: [permissions.readSettings, permissions.readRoundingDefinition],
    },
    {
      id: 'documentRoundingDefinitionEdit',
      routerProps: {
        path: settingsRoutes.documentRoundingDefinitionsEdit,
        element: <DocumentRoundingDefinitionsEdit />,
      },
      requiredPermission: [permissions.readSettings, permissions.updateRoundingDefinition],
    },
    {
      id: 'discountApplicationMethod',
      routerProps: {
        path: settingsRoutes.discountApplicationMethod,
        element: <DiscountApplicationMethod />,
      },
      requiredPermission: [permissions.readSettings, permissions.workshopRead],
    },
    {
      id: 'invoiceCanceling',
      routerProps: {
        path: settingsRoutes.invoiceCanceling,
        element: <InvoiceCanceling />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.readInvoice,
        permissions.readNegativeDocumentCancellationDefinition,
      ],
    },
    {
      id: 'newInvoiceCanceling',
      routerProps: {
        path: settingsRoutes.newInvoiceCanceling,
        element: <CreateOrEditInvoiceCanceling />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.createNegativeDocumentCancellationDefinition,
      ],
    },
    {
      id: 'accountingProformaCreationOverview',
      routerProps: {
        path: settingsRoutes.proformaCreationOverview,
        element: <ProformaCreationOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readInvoice],
    },
    {
      id: 'vatTotalAndCalculationOverview',
      routerProps: {
        path: settingsRoutes.vatTotalAndCalculationOverview,
        element: <VatTotalAndCalculationOverview />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.readVatCalculationDefinition,
        permissions.readVatCheckTotalsDefinition,
      ],
    },
    {
      id: 'vatTotalAndCalculationDetail',
      routerProps: {
        path: settingsRoutes.vatTotalAndCalculationDetail,
        element: <VatTotalAndCalculationDetail />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.readVatCalculationDefinition,
        permissions.readVatCheckTotalsDefinition,
      ],
    },
    {
      id: 'vatTotalAndCalculationNew',
      routerProps: {
        path: settingsRoutes.vatTotalAndCalculationNew,
        element: <VatTotalAndCalculationDetail />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.createVatCalculationDefinition,
        permissions.createVatCheckTotalsDefinition,
      ],
    },
    {
      id: 'accountingTaxDocumentIssuedTypeOverview',
      routerProps: {
        path: settingsRoutes.taxDocumentIssuedType,
        element: <TaxDocumentIssuedTypeOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readTaxDocumentForPaymentSettings],
    },
    {
      id: 'accountingTaxDocumentImportTypeOverview',
      routerProps: {
        path: settingsRoutes.taxDocumentImportType,
        element: <TaxDocumentImportTypeOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readTaxDocumentForPaymentSettings],
    },
    {
      id: 'accountingTaxDocumentImportTypeNew',
      routerProps: {
        path: settingsRoutes.taxDocumentImportTypeNew,
        element: <TaxDocumentForPaymentImportTypeNew />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.createTaxDocumentForPaymentSettings,
      ],
    },
    {
      id: 'accountingTaxDocumentImportTypeDetail',
      routerProps: {
        path: settingsRoutes.taxDocumentImportTypeDetail,
        element: <TaxDocumentForPaymentImportTypeDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readTaxDocumentForPaymentSettings],
    },
    {
      id: 'accountingTaxDocumentIssuedTypeNew',
      routerProps: {
        path: settingsRoutes.taxDocumentIssuedTypeNew,
        element: <TaxDocumentForPaymentIssuedTypeNew />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.createTaxDocumentForPaymentSettings,
      ],
    },
    {
      id: 'accountingTaxDocumentIssuedTypeDetail',
      routerProps: {
        path: settingsRoutes.taxDocumentIssuedTypeDetail,
        element: <TaxDocumentForPaymentIssuedTypeDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readTaxDocumentForPaymentSettings],
    },
    {
      id: 'accountingInvoiceCostOverview',
      routerProps: {
        path: settingsRoutes.invoiceCostOverview,
        element: <InvoiceCostOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingOperationDefaultsOverview',
      routerProps: {
        path: settingsRoutes.accountingOperationDefaultsOverview,
        element: <OperationDefaultsOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingOperationDefaultsDetail',
      routerProps: {
        path: settingsRoutes.accountingOperationDefaultsDetail,
        element: <OperationDefaultsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'generatedDocumentsSettings',
      routerProps: {
        path: settingsRoutes.generatedDocuments,
        element: <GeneratedDocuments />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'accountingInvoiceCostNew',
      routerProps: {
        path: settingsRoutes.invoiceCostNew,
        element: <InvoiceCostDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingInvoiceCostDetail',
      routerProps: {
        path: settingsRoutes.invoiceCostDetail,
        element: <InvoiceCostDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingProformaCreationDetail',
      routerProps: {
        path: settingsRoutes.proformaCreationEdit,
        element: <ProformaCreationDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readInvoice],
    },
    {
      id: 'accountingProformaCreationCreate',
      routerProps: {
        path: settingsRoutes.proformaCreationCreate,
        element: <ProformaCreationDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readInvoice],
    },
    {
      id: 'accountingMatrixManagement',
      routerProps: {
        path: settingsRoutes.accountingMatrixManagement,
        element: <MatrixManagement />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'exportParameters',
      routerProps: {
        path: settingsRoutes.exportParameters,
        element: <ExportParametersDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingCodes',
      routerProps: {
        path: settingsRoutes.accountingCodes,
        element: <AccountingCodes />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingCodesDetail',
      routerProps: {
        path: settingsRoutes.accountingCodesDetail,
        element: <AccountingCodesDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingOperationAuthorizations',
      routerProps: {
        path: settingsRoutes.accountingOperationAuthorizationsOverview,
        element: <OperationAuthorizationsOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingOperationAuthorizationsDetail',
      routerProps: {
        path: settingsRoutes.accountingOperationAuthorizationDetail,
        element: <OperationAuthorizationDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingActivityLog',
      routerProps: {
        path: settingsRoutes.accountingActivityLog,
        element: <AccountingActivityLog />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingErrorLog',
      routerProps: {
        path: settingsRoutes.accountingErrorLog,
        element: <AccountingErrorLog />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingErrorLogDetail',
      routerProps: {
        path: settingsRoutes.accountingErrorLogDetail,
        element: <AccountingErrorLogDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'preAccountingProcessingOverview',
      routerProps: {
        path: settingsRoutes.preAccountingProcessingOverview,
        element: <PreAccountingProcessingOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'preAccountingProcessingNew',
      routerProps: {
        path: settingsRoutes.preAccountingProcessingNew,
        element: <PreAccountingProcessingNew />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'preAccountingProcessingDetail',
      routerProps: {
        path: settingsRoutes.preAccountingProcessingDetail,
        element: <PreAccountingProcessingDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingIntegrations',
      routerProps: {
        path: settingsRoutes.accountingIntegrations,
        element: <AccountingIntegrations />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'accountingIntegrationsAbra',
      routerProps: {
        path: settingsRoutes.accountingIntegrationsAbra,
        element: <AccountingIntegrationsAbra />,
      },
      requiredPermission: [permissions.readSettings, permissions.readPreAccountingProcessing],
    },
    {
      id: 'invoiceCancelingDetail',
      routerProps: {
        path: settingsRoutes.invoiceCancelingDetail,
        element: <CreateOrEditInvoiceCanceling />,
      },
      requiredPermission: [
        permissions.readSettings,
        permissions.updateNegativeDocumentCancellationDefinition,
      ],
    },
    {
      id: 'documentRoundingDefinitionAdd',
      routerProps: {
        path: settingsRoutes.documentRoundingDefinitionsAdd,
        element: <DocumentRoundingDefinitionsNew />,
      },
      requiredPermission: [permissions.readSettings, permissions.createRoundingDefinition],
    },
    {
      id: 'vehicleServices',
      routerProps: {
        path: settingsRoutes.vehicleServices,
        element: <VehicleServices />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'autostacjaSettings',
      routerProps: {
        path: settingsRoutes.autostacjaSettings,
        element: <AutostacjaSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'autostacjaSettingsSubscriptionKey',
      routerProps: {
        path: settingsRoutes.autostacjaSettingsSubscriptionKey,
        element: <AutostacjaSettingsSubscriptionKey />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'jbr',
      routerProps: {
        path: settingsRoutes.jbr,
        element: <Jbr />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'jbrSettings',
      routerProps: {
        path: settingsRoutes.jbrSettings,
        element: <JbrSettingsCredentials />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesCarpass',
      routerProps: {
        path: settingsRoutes.vehicleServicesCarpass,
        element: <CarpassSettings />,
      },
      requiredPermission: [permissions.readSettings, permissions.canReadCarPassRequest],
    },
    {
      id: 'vehicleServicesCarpassDetail',
      routerProps: {
        path: settingsRoutes.vehicleServicesCarpassDetail,
        element: <CarpassSettingsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.canReadCarPassRequest],
    },
    {
      id: 'vehicleServicesCebia',
      routerProps: {
        path: settingsRoutes.vehicleServicesCebia,
        element: <Cebia />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesFeatures',
      routerProps: {
        path: settingsRoutes.vehicleServicesFeatures,
        element: <Features />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesCebiaRokvy',
      routerProps: {
        path: settingsRoutes.vehicleServicesRokVy,
        element: <CebiaRokvy />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleServicesDat',
      routerProps: {
        path: settingsRoutes.vehicleServicesDat,
        element: <DatVinDecoder />,
      },
      requiredPermission: [permissions.readSettings, permissions.updateDatVinDecoderConfig],
      requiredFeatureFlag: featureFlags.DAT_VIN_DECODER,
    },
    {
      id: 'smsGateways',
      routerProps: {
        path: settingsRoutes.smsGateways,
        element: <SmsGateways />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'smsGatewaysKonzulta',
      routerProps: {
        path: settingsRoutes.smsGatewaysKonzulta,
        element: <SmsGatewaysKonzulta />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'whatsApp',
      routerProps: {
        path: settingsRoutes.whatsApp,
        element: <WhatsApp />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.WHATSAPP_INTEGRATION,
    },
    {
      id: 'facebookCredentials',
      routerProps: {
        path: settingsRoutes.facebookCredentials,
        element: <FacebookCredentials />,
      },
      requiredPermission: [permissions.readSettings, permissions.readFacebookLeads],
      requiredFeatureFlag: featureFlags.SETTINGS_FACEBOOK,
    },
    {
      id: 'proformaGeneration',
      routerProps: {
        path: settingsRoutes.proformaGeneration,
        element: <ProformaInvoiceGenerationOverview />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'proformaGenerationDetail',
      routerProps: {
        path: settingsRoutes.proformaGenerationDetail,
        element: <ProformaInvoiceGenerationDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'proformaGenerationNew',
      routerProps: {
        path: settingsRoutes.proformaGenerationNew,
        element: <ProformaInvoiceGenerationNew />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'invoiceMargin',
      routerProps: {
        path: settingsRoutes.invoiceMarginOverview,
        element: <InvoiceMarginOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.readMarginInvoiceSettings],
    },
    {
      id: 'invoiceMargin',
      routerProps: {
        path: settingsRoutes.newInvoiceMargin,
        element: <InvoiceMarginDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.createMarginInvoiceSettings],
    },
    {
      id: 'invoiceMarginDetail',
      routerProps: {
        path: settingsRoutes.invoiceMarginDetail,
        element: <InvoiceMarginDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.updateMarginInvoiceSettings],
    },
    {
      id: 'emailServices',
      routerProps: {
        path: settingsRoutes.emailServices,
        element: <EmailServices />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerVerification',
      routerProps: {
        path: settingsRoutes.customerVerificationServices,
        element: <CustomerVerification />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerVerificationDistraints',
      routerProps: {
        path: settingsRoutes.customerVerificationDistraints,
        element: <CustomerVerificationDistraints />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'reservation',
      routerProps: {
        path: settingsRoutes.reservation,
        element: <Reservation />,
      },
    },
    {
      // Financing settings moved to the Purchase price page; keep old links and bookmarks working.
      // Declared before `financing` so the route catalog keeps describing the legacy page itself.
      id: 'financingRedirect',
      routerProps: {
        path: settingsRoutes.financing,
        element: <Navigate to={settingsRoutes.purchasePrice} replace />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_PURCHASE_PRICE,
    },
    {
      id: 'financing',
      routerProps: {
        path: settingsRoutes.financing,
        element: <Financing />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: (resolve) =>
        resolve(featureFlags.SALES_COSTS_WITH_VAT) && !resolve(featureFlags.SALES_PURCHASE_PRICE),
    },
    {
      id: 'purchasePrice',
      routerProps: {
        path: settingsRoutes.purchasePrice,
        element: <PurchasePrice />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_PURCHASE_PRICE,
    },
    {
      id: 'purchasePriceRuleNew',
      routerProps: {
        path: settingsRoutes.purchasePriceRuleNew,
        element: <PurchasePriceRuleNew />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_PURCHASE_PRICE,
    },
    {
      id: 'purchasePriceRuleDetail',
      routerProps: {
        path: settingsRoutes.purchasePriceRuleDetail,
        element: <PurchasePriceRuleDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SALES_PURCHASE_PRICE,
    },
    {
      id: 'locale',
      routerProps: {
        path: settingsRoutes.locale,
        element: <Locale />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'inspections',
      routerProps: {
        path: settingsRoutes.inspections,
        element: <Inspections />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'inspectionsDetail',
      routerProps: {
        path: settingsRoutes.inspectionDetail,
        element: <InspectionsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workType',
      routerProps: {
        path: settingsRoutes.workType,
        element: <WorkType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workTypeCreate',
      routerProps: {
        path: settingsRoutes.workTypeCreate,
        element: <WorkTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workTypeDetail',
      routerProps: {
        path: settingsRoutes.workTypeDetail,
        element: <WorkTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'employeeCompetences',
      routerProps: {
        path: settingsRoutes.employeeCompetences,
        element: <EmployeeCompetencesOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCompetencesCreate',
      routerProps: {
        path: settingsRoutes.employeeCompetencesCreate,
        element: <EmployeeCompetencesDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCompetencesDetail',
      routerProps: {
        path: settingsRoutes.employeeCompetencesDetail,
        element: <EmployeeCompetencesDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'vehicleGroups',
      routerProps: {
        path: settingsRoutes.vehicleGroups,
        element: <VehicleGroups />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleGroupsCreate',
      routerProps: {
        path: settingsRoutes.vehicleGroupsCreate,
        element: <VehicleGroupsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'vehicleGroupsDetail',
      routerProps: {
        path: settingsRoutes.vehicleGroupsDetail,
        element: <VehicleGroupsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warrantyTypes',
      routerProps: {
        path: settingsRoutes.warrantyTypes,
        element: <WarrantyTypes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warrantyTypesCreate',
      routerProps: {
        path: settingsRoutes.warrantyTypesCreate,
        element: <WarrantyTypesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'warrantyTypesDetail',
      routerProps: {
        path: settingsRoutes.warrantyTypesDetail,
        element: <WarrantyTypesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'chatSettings',
      routerProps: {
        path: settingsRoutes.chatSettings,
        element: <ChatSettings />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'employeeCostCenters',
      routerProps: {
        path: settingsRoutes.employeeCostCenters,
        element: <EmployeeCostCentersOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCostCentersCreate',
      routerProps: {
        path: settingsRoutes.employeeCostCentersCreate,
        element: <EmployeeCostCentersDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeCostCentersDetail',
      routerProps: {
        path: settingsRoutes.employeeCostCentersDetail,
        element: <EmployeeCostCentersDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeWorkTeams',
      routerProps: {
        path: settingsRoutes.employeeWorkTeams,
        element: <EmployeeWorkTeamsOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeWorkTeamsCreate',
      routerProps: {
        path: settingsRoutes.employeeWorkTeamsCreate,
        element: <EmployeeWorkTeamsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeWorkTeamsDetail',
      routerProps: {
        path: settingsRoutes.employeeWorkTeamsDetail,
        element: <EmployeeWorkTeamsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'labourRates',
      routerProps: {
        path: settingsRoutes.labourRates,
        element: <LabourRates />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourRatesCreate',
      routerProps: {
        path: settingsRoutes.labourRatesCreate,
        element: <LabourRatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourRatesDetail',
      routerProps: {
        path: settingsRoutes.labourRatesDetail,
        element: <LabourRatesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'employeeProfessions',
      routerProps: {
        path: settingsRoutes.employeeProfessions,
        element: <EmployeeProfessionsOverview />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeProfessionsCreate',
      routerProps: {
        path: settingsRoutes.employeeProfessionsCreate,
        element: <EmployeeProfessionsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'employeeProfessionsDetail',
      routerProps: {
        path: settingsRoutes.employeeProfessionsDetail,
        element: <EmployeeProfessionsDetail />,
      },
      requiredPermission: [permissions.readSettings, permissions.employeeRead],
    },
    {
      id: 'serviceCaseType',
      routerProps: {
        path: settingsRoutes.serviceCaseType,
        element: <ServiceCaseType />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceCaseTypeDetail',
      routerProps: {
        path: settingsRoutes.serviceCaseTypeDetail,
        element: <ServiceCaseTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceCaseTypeCreate',
      routerProps: {
        path: settingsRoutes.serviceCaseTypeCreate,
        element: <ServiceCaseTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceOrderVariants',
      routerProps: {
        path: settingsRoutes.serviceOrderVariants,
        element: <WorkshopServiceOrderVariants />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceOrderVariantsCreate',
      routerProps: {
        path: settingsRoutes.serviceOrderVariantsCreate,
        element: <ServiceOrderVariantsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'serviceOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.serviceOrderVariantsDetail,
        element: <ServiceOrderVariantsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesServiceOrderVariants',
      routerProps: {
        path: settingsRoutes.salesServiceOrderVariants,
        element: <SalesServiceOrderVariants />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'salesServiceOrderVariantsDetail',
      routerProps: {
        path: settingsRoutes.salesServiceOrderVariantsDetail,
        element: <ServiceOrderVariantsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourCatalogues',
      routerProps: {
        path: settingsRoutes.labourCatalogues,
        element: <LabourCatalogues />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourCataloguesCreate',
      routerProps: {
        path: settingsRoutes.labourCataloguesCreate,
        element: <LabourCataloguesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'labourCataloguesDetail',
      routerProps: {
        path: settingsRoutes.labourCataloguesDetail,
        element: <LabourCataloguesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCustomerGroups',
      routerProps: {
        path: settingsRoutes.workshopCustomerGroups,
        element: <WorkshopCustomerGroups />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCustomerGroupCreate',
      routerProps: {
        path: settingsRoutes.workshopCustomerGroupCreate,
        element: <WorkshopCustomerGroupFormPage />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCustomerGroupDetail',
      routerProps: {
        path: settingsRoutes.workshopCustomerGroupDetail,
        element: <WorkshopCustomerGroupFormPage />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopSelectableMaterials',
      routerProps: {
        path: settingsRoutes.workshopSelectableMaterials,
        element: <WorkshopSelectableMaterials />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopSelectableMaterialsDetail',
      routerProps: {
        path: settingsRoutes.workshopSelectableMaterialsDetail,
        element: <WorkshopSelectableMaterialsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMinorUnitMaterial',
      routerProps: {
        path: settingsRoutes.workshopSmallUnitMaterial,
        element: <WorkshopSmallUnitMaterials />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMinorUnitMaterialDetail',
      routerProps: {
        path: settingsRoutes.workshopSmallUnitMaterialDetail,
        element: <WorkshopSmallUnitMaterialDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMinorUnitMaterialCreate',
      routerProps: {
        path: settingsRoutes.workshopSmallUnitMaterialCreate,
        element: <WorkshopSmallUnitMaterialDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerContracts',
      routerProps: {
        path: settingsRoutes.customerContracts,
        element: <CustomerContracts />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerContractsCreate',
      routerProps: {
        path: settingsRoutes.customerContractsCreate,
        element: <CustomerContractsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'customerContractsDetail',
      routerProps: {
        path: settingsRoutes.customerContractsDetail,
        element: <CustomerContractsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tiresInventory',
      routerProps: {
        path: settingsRoutes.tiresInventory,
        element: <TiresInventory />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tiresInventoryDetail',
      routerProps: {
        path: settingsRoutes.tiresInventoryDetail,
        element: <TiresInventoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tiresInventoryCreate',
      routerProps: {
        path: settingsRoutes.tiresInventoryCreate,
        element: <TiresInventoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireTransit',
      routerProps: {
        path: settingsRoutes.tireTransit,
        element: <TireTransit />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireTransitDetail',
      routerProps: {
        path: settingsRoutes.tireTransitDetail,
        element: <TireTransitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireTransitCreate',
      routerProps: {
        path: settingsRoutes.tireTransitCreate,
        element: <TireTransitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireManufacturers',
      routerProps: {
        path: settingsRoutes.tireManufacturers,
        element: <TireInventoryManufacturers />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLocations',
      routerProps: {
        path: settingsRoutes.tireLocations,
        element: <TireInventoryLocations />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWarehouses',
      routerProps: {
        path: settingsRoutes.tireWarehouses,
        element: <TireWarehouses />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWarehousesCreate',
      routerProps: {
        path: settingsRoutes.tireWarehousesCreate,
        element: <TireWarehousesCreate />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWarehousesDetail',
      routerProps: {
        path: settingsRoutes.tireWarehousesDetail,
        element: <TireWarehousesDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServicePackages',
      routerProps: {
        path: settingsRoutes.workshopServicePackages,
        element: <WorkshopServicePackages />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopCreateServicePackages',
      routerProps: {
        path: settingsRoutes.workshopCreateServicePackages,
        element: <WorkshopServicePackageDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopEditServicePackages',
      routerProps: {
        path: settingsRoutes.workshopEditServicePackages,
        element: <WorkshopServicePackageDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMeasurementUnits',
      routerProps: {
        path: settingsRoutes.workshopMeasurementUnits,
        element: <WorkshopMeasurementUnits />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMeasurementUnitCreate',
      routerProps: {
        path: settingsRoutes.workshopMeasurementUnitCreate,
        element: <WorkshopMeasurementUnitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopMeasurementUnitDetail',
      routerProps: {
        path: settingsRoutes.workshopMeasurementUnitDetail,
        element: <WorkshopMeasurementUnitDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServiceOrderGroups',
      routerProps: {
        path: settingsRoutes.workshopServiceOrderGroups,
        element: <WorkshopServiceOrderGroups />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServiceOrderGroupCreate',
      routerProps: {
        path: settingsRoutes.workshopServiceOrderGroupCreate,
        element: <WorkshopServiceOrderGroupDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopServiceOrderGroupDetail',
      routerProps: {
        path: settingsRoutes.workshopServiceOrderGroupDetail,
        element: <WorkshopServiceOrderGroupDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInterest',
      routerProps: {
        path: settingsRoutes.workshopInterest,
        element: <WorkshopInterest />,
      },
      requiredFeatureFlag: featureFlags.WORKSHOP_INTEREST,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInterestSeriesDefinition',
      routerProps: {
        path: settingsRoutes.workshopInterestSeriesDefinition,
        element: <WorkshopInterestSeriesDefinition />,
      },
      requiredFeatureFlag: featureFlags.WORKSHOP_INTEREST,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInterestSourceCodelist',
      routerProps: {
        path: settingsRoutes.workshopInterestSourceCodelist,
        element: <WorkshopCodelistDetail />,
      },
      requiredFeatureFlag: featureFlags.WORKSHOP_INTEREST,
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'generalChecklist',
      routerProps: {
        path: settingsRoutes.generalChecklist,
        element: <Checklist />,
      },
    },
    {
      id: 'generalChecklistCreate',
      routerProps: {
        path: settingsRoutes.generalChecklistCreate,
        element: <ChecklistCreate />,
      },
    },
    {
      id: 'generalChecklistDetail',
      routerProps: {
        path: settingsRoutes.generalChecklistDetail,
        element: <ChecklistDetail />,
      },
    },
    {
      id: 'recordAuditDefinition',
      routerProps: {
        path: settingsRoutes.recordAuditDefinition,
        element: <RecordAuditDefinition />,
      },
      requiredFeatureFlag: featureFlags.CORE_CHECKLIST_AUDITS,
      requiredPermission: permissions.recordAuditRead,
    },
    {
      id: 'recordAuditDefinitionCreate',
      routerProps: {
        path: settingsRoutes.recordAuditDefinitionCreate,
        element: <RecordAuditDefinitionCreate />,
      },
      requiredFeatureFlag: featureFlags.CORE_CHECKLIST_AUDITS,
      requiredPermission: permissions.recordAuditRead,
    },
    {
      id: 'recordAuditDefinitionDetail',
      routerProps: {
        path: settingsRoutes.recordAuditDefinitionDetail,
        element: <RecordAuditDefinitionDetail />,
      },
      requiredFeatureFlag: featureFlags.CORE_CHECKLIST_AUDITS,
      requiredPermission: permissions.recordAuditRead,
    },
    {
      id: 'recordAuditSeriesDefinition',
      routerProps: {
        path: settingsRoutes.recordAuditSeriesDefinition,
        element: <RecordAuditSeriesDefinition />,
      },
      requiredFeatureFlag: featureFlags.CORE_CHECKLIST_AUDITS,
      requiredPermission: permissions.recordAuditRead,
    },
    {
      id: 'tireWidth',
      routerProps: {
        path: settingsRoutes.tireWidth,
        element: <TireInventoryWidth />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWidthDetail  ',
      routerProps: {
        path: settingsRoutes.tireWidthDetail,
        element: <TireInventoryWidthDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireWidthCreate',
      routerProps: {
        path: settingsRoutes.tireWidthCreate,
        element: <TireInventoryWidthDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireAspectRatio',
      routerProps: {
        path: settingsRoutes.tireAspectRatio,
        element: <TireInventoryAspectRatio />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireAspectRatioDetail',
      routerProps: {
        path: settingsRoutes.tireAspectRatioDetail,
        element: <TireInventoryAspectRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireAspectRatioCreate',
      routerProps: {
        path: settingsRoutes.tireAspectRatioCreate,
        element: <TireInventoryAspectRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireRimSize',
      routerProps: {
        path: settingsRoutes.tireRimSize,
        element: <TireInventoryRim />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireRimSizeDetail',
      routerProps: {
        path: settingsRoutes.tireRimSizeDetail,
        element: <TireInventoryRimDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireRimSizeCreate',
      routerProps: {
        path: settingsRoutes.tireRimSizeCreate,
        element: <TireInventoryRimDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireSpeedRatio',
      routerProps: {
        path: settingsRoutes.tireSpeedRatio,
        element: <TireInventorySpeedRatio />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireSpeedRatioDetail',
      routerProps: {
        path: settingsRoutes.tireSpeedRatioDetail,
        element: <TireInventorySpeedRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireSpeedRatioCreate',
      routerProps: {
        path: settingsRoutes.tireSpeedRatioCreate,
        element: <TireInventorySpeedRatioDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCategory',
      routerProps: {
        path: settingsRoutes.tireCategory,
        element: <TireInventoryCategory />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCategoryDetail',
      routerProps: {
        path: settingsRoutes.tireCategoryDetail,
        element: <TireInventoryCategoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCategoryCreate',
      routerProps: {
        path: settingsRoutes.tireCategoryCreate,
        element: <TireInventoryCategoryDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireCondition',
      routerProps: {
        path: settingsRoutes.tireCondition,
        element: <TireCondition />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireConditionDetail',
      routerProps: {
        path: settingsRoutes.tireConditionDetail,
        element: <TireConditionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireConditionCreate',
      routerProps: {
        path: settingsRoutes.tireConditionCreate,
        element: <TireConditionDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopUnits',
      routerProps: {
        path: settingsRoutes.workshopUnits,
        element: <WorkshopUnits />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopUnitCreate',
      routerProps: {
        path: settingsRoutes.workshopUnitCreate,
        element: <WorkshopUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopUnitDetail',
      routerProps: {
        path: settingsRoutes.workshopUnitDetail,
        element: <WorkshopUnitsDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLoadIndex',
      routerProps: {
        path: settingsRoutes.tireLoadIndex,
        element: <TireInventoryLoadIndex />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLoadIndexDetail',
      routerProps: {
        path: settingsRoutes.tireLoadIndexDetail,
        element: <TireInventoryLoadIndexDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'tireLoadIndexCreate',
      routerProps: {
        path: settingsRoutes.tireLoadIndexCreate,
        element: <TireInventoryLoadIndexDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'mandatoryFields',
      routerProps: {
        path: settingsRoutes.mandatoryFields,
        element: <MandatoryFields />,
      },
      requiredPermission: permissions.readMandatoryFields,
    },
    {
      id: 'workshopVehicleClasses',
      routerProps: {
        path: settingsRoutes.workshopVehicleClasses,
        element: <WorkshopVehicleClasses />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopVehicleClassCreate',
      routerProps: {
        path: settingsRoutes.workshopVehicleClassCreate,
        element: <WorkshopVehicleClassDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopVehicleClassDetail',
      routerProps: {
        path: settingsRoutes.workshopVehicleClassDetail,
        element: <WorkshopVehicleClassDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInsuranceTypes',
      routerProps: {
        path: settingsRoutes.workshopInsuranceTypes,
        element: <WorkshopInsuranceTypes />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInsuranceTypesCreate',
      routerProps: {
        path: settingsRoutes.workshopInsuranceTypesCreate,
        element: <WorkshopInsuranceTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'workshopInsuranceTypesDetail',
      routerProps: {
        path: settingsRoutes.workshopInsuranceTypesDetail,
        element: <WorkshopInsuranceTypeDetail />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'partDepartment',
      routerProps: {
        path: settingsRoutes.partDepartment,
        element: <PartDepartment />,
      },
      requiredPermission: permissions.readSettings,
    },
    {
      id: 'twoFactorSettings',
      routerProps: {
        path: settingsRoutes.twoFactorSettings,
        element: <TwoFactorSettings />,
      },
      requiredPermission: permissions.canReadTenantMultiFactorAuthenticationSettings,
      requiredFeatureFlag: featureFlags.SETTINGS_TWO_FACTOR_AUTH,
    },
    {
      id: 'scheduledMessages',
      routerProps: {
        path: settingsRoutes.scheduledMessages,
        element: <ScheduledMessagesOverview />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SCHEDULED_MESSAGES,
    },
    {
      id: 'scheduledMessagesDetail',
      routerProps: {
        path: settingsRoutes.scheduledMessagesDetail,
        element: <ScheduledMessagesDetail />,
      },
      requiredPermission: permissions.readSettings,
      requiredFeatureFlag: featureFlags.SCHEDULED_MESSAGES,
    },
  ],
};
